module.exports = __webpack_public_path__ + "img/dashboard_sale_icon.22115f0a.svg";